import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=462ba516&scoped=true&lang=pug&"
import script from "./HomeLayout.vue?vue&type=script&lang=js&"
export * from "./HomeLayout.vue?vue&type=script&lang=js&"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=462ba516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ba516",
  null
  
)

export default component.exports